import { render, staticRenderFns } from "./sub-overview.vue?vue&type=template&id=359da2bb&scoped=true&"
import script from "./sub-overview.vue?vue&type=script&lang=js&"
export * from "./sub-overview.vue?vue&type=script&lang=js&"
import style0 from "./sub-overview.vue?vue&type=style&index=0&id=359da2bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359da2bb",
  null
  
)

export default component.exports